import { Guid } from 'guid-typescript';

export class ImportBfwdModel {
  ireturnFormId: Guid;
  returnFormId: Guid;
}
